<template>
  <div>
    <div class="h-i-3">
      <div class="i-3-1">让我了解您的需求，为您提供免费方案</div>
      <div class="i-3-2" @click="demand">获取方案</div>
      <!-- <div class="i-3-3"></div> -->
      <!-- <div class="i-3-4">专业化的团队，为您提供更完善的解决方案</div> -->
      <!-- <div class="i-3-5" @click="demand">我要提出需求</div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      minWidth:'',
    }
  },
  mounted() {
    window.addEventListener('resize', this.getWidth);
    this.getWidth()
  },
  methods: {
    getWidth(){
      // this.height = window.innerWidth - 70 + 'px';
      this.minWidth = String(window.innerWidth)
    },
    demand() { // 跳转客服
      // window.open()
      KS.openChatWin()
    }
  },
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 500px) {
  .h-i-3 {
      width: 100%;
      height: 800px;
      background: url(../assets/img/scheme/scheme.png) no-repeat;
      background-size: 100% 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
      // overflow-x:auto;
      .i-3-1 {
        font-size: 46px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
      }
      .i-3-2 {
        width: 220px;
        height: 70px;
        border: 1px solid #FFFFFF;
        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        text-align: center;
        line-height: 70px;
        margin-top: 60px;
        cursor: pointer;
      }
      .i-3-3 {
        width: 1200px;
        height: 1px;
        background: #FFFFFF;
        margin-top: 90px;
      }
      .i-3-4 {
        font-size: 46px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: 100px;
      }
      .i-3-5 {
        width: 300px;
        height: 60px;
        background: #FFFFFF;
        cursor: pointer;
        font-size: 32px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #033360;
        margin-top: 70px;
        text-align: center;
        line-height: 60px;;
      }
    }
}
@media screen and (min-width:359px) and (max-width: 500px) {
  .h-i-3 {
    width: 100%;
    height: 280px;
    background: url(../assets/app/sean.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    // padding-bottom: 200px;
    .i-3-1 {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
    }
    .i-3-2 {
      width: 40%;
      height: 35px;
      border: 1px solid #FFFFFF;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
      text-align: center;
      line-height: 35px;
      margin-top: 20px;
      cursor: pointer;
    }
    .i-3-3 {
      width: 90%;
      height: 1px;
      background: #FFFFFF;
      margin: 0 auto;
      margin-top: 20px;
    }
    .i-3-4 {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #FFFFFF;
      margin-top: 20px;
    }
    .i-3-5 {
      width: 40%;
      height: 30px;
      background: #FFFFFF;
      font-size: 10px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #033360;
      margin-top: 30px;
      text-align: center;
      line-height: 30px;;
    }
  }
}
</style>
